/* ============================================================
   CULT RACING — PERSONALIZATION FIELD  (page-neutral)

   A personalized lot lets the buyer type the text that gets PRINTED
   on the garment. The value rides to Shopify as a native line item
   property, so it reaches the cart, the real checkout, the order and
   the packing slip with no app and no extra API scope.

   Loads AFTER drop-page.js and owns only the input's manners:
   normalising keystrokes, the counter, the live "this is what gets
   printed" echo, and clearing the error state. It deliberately does
   NOT touch the cart.

   THE MONEY PATH DOES NOT DEPEND ON THIS FILE. drop-page.js gates the
   add on native constraint validation (required + pattern, rendered
   in Liquid), so a blank or malformed tag is refused even if this
   script fails to load or a browser blocks it. This only makes the
   field pleasant; the markup makes it correct.

   Driven entirely by data attributes, so any page that renders them
   gets the feature by loading this pair:
     [data-personalize]            the field wrapper
     [data-personalize-input]      the input (carries required+pattern)
     [data-personalize-name]       Shopify property name, e.g. "Tag"
     [data-personalize-count]      optional "n/20" counter
     [data-personalize-echo]       optional live echo of the printed text
     [data-personalize-error]      set to "true" by drop-page.js on refusal
   ============================================================ */
(function () {
  "use strict";

  var fields = [].slice.call(document.querySelectorAll("[data-personalize]"));
  if (!fields.length) return;

  fields.forEach(function (field) {
    var input = field.querySelector("[data-personalize-input]");
    if (!input) return;

    var count = field.querySelector("[data-personalize-count]");
    var echo = field.querySelector("[data-personalize-echo]");
    var max = parseInt(input.getAttribute("maxlength"), 10) || 20;
    var placeholder = input.getAttribute("placeholder") || "";

    /* Mudit, 2026-08-21: periods, underscores and symbols must survive, because
       Instagram handles use them and people want them printed. This used to
       strip everything except letters and numbers, which silently turned
       "@my.handle" into "MYHANDLE" — the buyer saw it happen but had no way to
       stop it.

       Now only two things are enforced here: UPPERCASE, because the back print
       is one uppercase run and the echo plate should show what is actually
       going on the garment, and the length cap. Leading and trailing spaces are
       trimmed by drop-page.js before the value becomes a line item property, so
       they cannot reach the order even though they are typeable. */
    /* The script obeys the rule the MARKUP declares, it does not assume one.

       That matters because this storefront's page_cache can serve a stale
       compile: a cached page carrying the OLD letters-and-numbers pattern could
       be paired with THIS newer script. Without the fallback the buyer would be
       allowed to type "MY.HANDLE", see it accepted, and then have the add
       silently refused by native validation with no idea why. Reading the
       pattern off the input makes both combinations correct, and it keeps
       working if the rule is ever changed again in Liquid alone. */
    var patSrc = input.getAttribute("pattern");
    var patRe = null;
    if (patSrc) { try { patRe = new RegExp("^(?:" + patSrc + ")$"); } catch (e) { patRe = null; } }

    function clean(s) {
      var v = s.toUpperCase().slice(0, max);
      if (v && patRe && !patRe.test(v)) v = v.replace(/[^A-Za-z0-9]/g, "");
      return v;
    }

    function paint() {
      var v = input.value;
      if (count) count.textContent = v.length + "/" + max;
      if (echo) {
        echo.textContent = v || placeholder;
        echo.setAttribute("data-personalize-empty", v ? "false" : "true");
      }
      /* the buyer is fixing it, so stop shouting */
      if (v && input.checkValidity()) field.removeAttribute("data-personalize-error");
    }

    input.addEventListener("input", function () {
      var before = input.value;
      var next = clean(before);
      if (next !== before) {
        /* Rewriting .value parks the caret at the end, which makes editing the
           middle of a tag impossible. Count how many characters survived
           cleaning up to the old caret and put it back there. */
        var caret = input.selectionStart;
        var kept = clean(before.slice(0, caret)).length;
        input.value = next;
        try { input.setSelectionRange(kept, kept); } catch (e) {}
      }
      paint();
    });

    /* A paste lands as an input event in every browser we support, so there is
       no separate paste handler. Blur is where a trailing edit settles. */
    input.addEventListener("blur", paint);

    paint();
  });
})();
